// extracted by mini-css-extract-plugin
export default {"filter":"Products_filter__6R5zr","filterWrapper":"Products_filterWrapper__zTs01","filter__block":"Products_filter__block__xV7Tn"};